import Vue from 'vue'
import moment from 'moment'

Vue.filter('NumberFormat', function (value) {
  if (!value) {
    return '0'
  }
  const intPartFormat = value.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') //将整数部分逢三一断
  return intPartFormat
})

Vue.filter ('dayjs', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

Vue.filter ('moment', function(dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})
// 时间戳转化
export function getTimeChange(text,type){
  let date = new Date(text);
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? "0" + MM : MM;
  let d = date.getDate();
  d = d < 10 ? "0" + d : d;
  let h = date.getHours();
  h = h < 10 ? "0" + h : h;
  let m = date.getMinutes();
  m = m < 10 ? "0" + m : m;
  let s = date.getSeconds();
  s = s < 10 ? "0" + s : s;
  if(type==1){
    return y + "-" + MM + "-" + d ;
  }else{
    return y + "-" + MM + "-" + d + " " + h + ":" + m ;
  } 
}
// 获取所有联动信息
export function getCityAllList(startArr){
  let arr = []
  startArr.map(item => {
      arr.push({
          label: item[Object.keys(item)[0]].name,
          value: item[Object.keys(item)[0]].id,
          children: item[Object.keys(item)[1]].map(item => {
              return {
                  label: item[Object.keys(item)[0]].name,
                  value: item[Object.keys(item)[0]].id,
                  children: item[Object.keys(item)[1]].map(item => {
                      return {
                          label: item[Object.keys(item)[0]].name,
                          value: item[Object.keys(item)[0]].id
                      }
                  })
              }
          })
      })
  })
  return arr
}


// WEBPACK FOOTER //
// ./src/utils/filter.js